import {ActionsOf, init} from "../utils";
import * as types from "../../constants";
import * as actions from "../actions-declarations/toasts";

export type ErrorsActions = typeof actions

export type TypeStateToast = {
  name?: string,
  message: string,
  method: string,
  url: string,
  type: string,
}

export default function reducer(
  state = init({
    toasts: [] as TypeStateToast[],
  }),
  actions: ActionsOf<ErrorsActions>
): typeof state {
  switch (actions.type) {
    case types.ADD_TOAST:
      let toast = {
        name: 'Error',
        message: 'Unexpected error',
        method: 'Error',
        url: '',
        type: 'error'
      }

      if (actions.payload.type) {
        toast.type = actions.payload.type
      }
      if (actions.payload.name) {
        toast.name = actions.payload.name
      }
      if (actions.payload.message) {
        toast.message = actions.payload.message
      }
      if (actions.payload.config && actions.payload.config.method) {
        toast.method = actions.payload.config.method
      }
      if (actions.payload.config && actions.payload.config.url) {
        toast.url = actions.payload.config.url
      }
      return {
        ...state,
        toasts: [
          ...state.toasts,
          toast
          ],
      };
    case types.REMOVE_TOAST:
      return {
        ...state,
        toasts: state.toasts.filter((i, index) => index !== actions.payload),
      };
    case types.REMOVE_TOASTS:
      return {
        ...state,
        toasts: []
      }
    default:
      return state;
  }
}
